function salaryCalc() {

  function SalaryFields(initConfig) {
    const config = typeof initConfig !== 'undefined' ? initConfig : {
      selectors: {
        wrapper: '.calculate',
        salaryFieldWrapper: '.field',
        dateFromField: '.job-start-input',
        dateToField: '.job-end-input',
        salaryField: '.calc-section__salary-input',
        calculateBtn: '.calc-section__result-submit-btn',
        childrenCount: '.calc-section__count-section-item-input--children',
        childrenCrippleCount: '.calc-section__count-section-item-input--cripple',
        radioWrapperPspSelf: '.calc-section__count-section-item-radio-wrap--psp-self',
        radioWrapperPspKids: '.calc-section__count-section-item-radio-wrap--psp-kids',
        radioWrapperEsv: '.calc-section__count-section-item-radio-wrap--esv',
        selectEsv: '.js--select_esv',
        radioElem: '.calc-section__count-section-item-radio',
        childRadio: "#psp-kids-1",
        crippleChildRadio: "#psp-kids-2",
        error: '.invalid'
      },
      classes: {
        error: 'invalid',
      }
    };

    const elements = {};

    const callbacksCollection = {
      calculateSalary: new Set()
    };

    const validationRules = {
      salaryField: function (value) {
        return value && /[\d]?[\d.]*[\d]{2}/g.test(Number(value));
      },
      dateValid: function (value) {
        return value && /[\d]?[\d.]*[\d]{2}/g.test(value);
      },
      childrenFieldValid: function (value) {
        return true;
      }
    };

    const radioElemData = {
      dataPspSelf: 100,
      dataPspKids: 0,
      dataEsv: 22
    };

    const salaryData = {
      dateFrom: '',
      dateTo: '',
      salary: 0,
      childrenCount: 0,
      childrenCrippleCount: 0,
      radioData: radioElemData
    };

    function initElements() {
      elements.wrapper = document.querySelector(config.selectors.wrapper);
      if (!elements.wrapper) return;

      elements.dateFromField = elements.wrapper.querySelector(config.selectors.dateFromField);
      elements.dateToField = elements.wrapper.querySelector(config.selectors.dateToField);
      elements.salaryField = elements.wrapper.querySelector(config.selectors.salaryField);
      elements.childrenCount = elements.wrapper.querySelector(config.selectors.childrenCount);
      elements.childrenCountField = elements.childrenCount?.closest(config.selectors.salaryFieldWrapper);
      elements.childrenCrippleCount = elements.wrapper.querySelector(config.selectors.childrenCrippleCount);
      elements.childrenCrippleCountField = elements.childrenCrippleCount?.closest(config.selectors.salaryFieldWrapper);
      elements.dateFromFieldWrapper = elements.dateFromField?.closest(config.selectors.salaryFieldWrapper);
      elements.dateToFieldWrapper = elements.dateToField?.closest(config.selectors.salaryFieldWrapper);
      elements.salaryFieldWrapper = elements.salaryField?.closest(config.selectors.salaryFieldWrapper);
      elements.radioWrapperPspSelf = elements.wrapper.querySelector(config.selectors.radioWrapperPspSelf);
      elements.radioWrapperPspKids = elements.wrapper.querySelector(config.selectors.radioWrapperPspKids);
      elements.radioWrapperEsv = elements.wrapper.querySelector(config.selectors.radioWrapperEsv);
      elements.selectEsv = elements.wrapper.querySelector(config.selectors.selectEsv);
      elements.radioElem = elements.wrapper.querySelectorAll(config.selectors.radioElem);
      elements.childRadio = elements.wrapper.querySelector(config.selectors.childRadio);
      elements.crippleChildRadio = elements.wrapper.querySelector(config.selectors.crippleChildRadio);
      elements.calculateBtn = elements.wrapper.querySelector(config.selectors.calculateBtn);
    }

    function highlightInvalidFields() {
      if (!Boolean(elements.salaryField.value)) {
        elements.salaryFieldWrapper.classList.add(config.classes.error);
        elements.salaryField.classList.add(config.classes.error);
      } else {
        elements.salaryFieldWrapper.classList.remove(config.classes.error);
        elements.salaryField.classList.remove(config.classes.error);
      }
    }

    function isFormValid() {
      highlightInvalidFields();

      return elements.wrapper.querySelectorAll(config.selectors.error).length === 0;
    }

    function disableChildRadioGroup() {
      var childrenCount = Number(elements.childrenCount.value),
          childrenCrippleCount = Number(elements.childrenCrippleCount.value),
          isChildFieldsComplete = childrenCrippleCount && childrenCrippleCount !== 0,
          isChildComplete = childrenCount && !childrenCrippleCount,
          isChildFieldsEmpty = !childrenCount && !childrenCrippleCount;
    }

    function salaryStringPattern(str) {
      return str.replace(/[^\d.]/ig, '').replace(/^([^.]*\.)(.*)$/, function (a, b, c) {
        return b + c.replace(/\./g, '');
      });
    }

    function setEventListeners() {
      elements.salaryField.addEventListener('input', function () {
        let isValid = false;

        this.value = salaryStringPattern(this.value);
        isValid = validationRules.childrenFieldValid(this.value);

        elements.salaryFieldWrapper.classList.toggle(config.classes.error, !isValid);
        this.classList.toggle(config.classes.error, !isValid);

        if (isValid) {
          salaryData.salary = this.value;
        }
      });
      elements.childrenCrippleCount.addEventListener('input', function () {
        let value = Number(this.value.replace(/[^0-9]/ig, ''));
        let isValid = validationRules.childrenFieldValid(value);

        this.value = value;
        elements.childrenCrippleCountField.classList.toggle(config.classes.error, !isValid);
        disableChildRadioGroup();

        if (isValid) {
          salaryData.childrenCrippleCount = value ? value : 0;
        }
      });
      elements.childrenCount.addEventListener('input', function () {
        let value = Number(this.value.replace(/[^0-9]/ig, ''));
        let isValid = validationRules.childrenFieldValid(value);

        this.value = value;
        elements.childrenCountField.classList.toggle(config.classes.error, !isValid);
        disableChildRadioGroup();
        if (isValid) {
          salaryData.childrenCount = value ? value : 0;
        }
      });
      elements.dateFromField.addEventListener('change', function () {
        let isValid = validationRules.dateValid(this.value);
        elements.dateFromFieldWrapper.classList.toggle(config.classes.error, !isValid);
        this.classList.toggle(config.classes.error, !isValid);

        if (isValid) {
          salaryData.dateFrom = this.value;
        }
      });
      elements.dateToField.addEventListener('change', function () {
        let isValid = validationRules.dateValid(this.value);
        elements.dateToFieldWrapper.classList.toggle(config.classes.error, !isValid);
        this.classList.toggle(config.classes.error, !isValid);

        if (isValid) {
          salaryData.dateTo = this.value;
        }
      });

      elements.radioWrapperPspSelf.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) {
          radioElemData.dataPspSelf = Number(e.target.dataset.value);
        }
      });

      // elements.$radioWrapperPspKids.on('change', elements.$radioElem, function (e) {
      //     radioElemData.dataPspKids = elements.$radioWrapperPspKids.find('input[type="radio"]:checked').data('value');
      // });

      // elements.radioWrapperEsv.addEventListener('change', function (e) {
      //   if (e.target.matches('input[type="radio"]')) {
      //     radioElemData.dataEsv = e.target.dataset.value;
      //   }
      // });
      elements.selectEsv.addEventListener('change', function () {
        const value = this.value;
        radioElemData.dataEsv = Number(value);
      });

      elements.calculateBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isFormValid()) {
          callbacksCollection.calculateSalary.forEach(function(callback) {
            callback(salaryData);
          });
        }
      });
    }

    function initComponents() {
      var currentDate = new Date();

      // $('.job-start-input').datepicker("option", "minDate", new Date(2016, 1 - 1, 1)).datepicker("setDate", currentDate).mask('99.99.9999');

      salaryData.dateFrom = elements.dateFromField ? elements.dateFromField.value : '';
    }

    this.subscribe = function (type, callback) {
      callbacksCollection[type].add(callback);
    };

    (function init() {
      initElements();
      initComponents();
      setEventListeners();
    })();
  }

  function SalaryResults(initConfig) {
    const config = initConfig || {
          selectors: {
            wrapper: '',
            table: '',
            pspValue: '',
            pspEdgeValue: '',
            ndflValue: '',
            vzValue: '',
            salaryValue: '',
            salaryEsvValue: '',
            salaryEsvFactValue: '',
            salaryEsvFactValueWrap: ''
          }
        },
        elements = {};

    function initElements() {
      elements.$wrapper = document.querySelector(config.selectors.wrapper);
      elements.$table = elements.$wrapper.querySelector(config.selectors.table);
      elements.$pspValue = elements.$table.querySelector(config.selectors.pspValue);
      elements.$pspEdgeValue = elements.$table.querySelector(config.selectors.pspEdgeValue);
      elements.$ndflValue = elements.$table.querySelector(config.selectors.ndflValue);
      elements.$vzValue = elements.$table.querySelector(config.selectors.vzValue);
      elements.$salaryValue = elements.$table.querySelector(config.selectors.salaryValue);
      elements.$salaryEsvFactValue = elements.$table.querySelector(config.selectors.salaryEsvFactValue);
      elements.$salaryEsvValue = elements.$table.querySelector(config.selectors.salaryEsvValue);
      elements.$salaryEsvValueWrap = elements.$table.querySelector(config.selectors.salaryEsvFactValueWrap);
    }

    function setCalculatedData($field, value) {
      $field.innerHTML = value;
    }

    function isESVFactFieldVisible(fieldsData) {
      return Boolean(fieldsData.radioData.dataEsv === 22);
    }

    this.setData = function (data, fieldsData) {

      // data.PDFO = data.PDFO < 0 ? 0 : data.PDFO;

      setCalculatedData(elements.$pspValue, data.totalPSP);
      setCalculatedData(elements.$pspEdgeValue, data.salaryEDGE);
      setCalculatedData(elements.$ndflValue, data.PDFO);
      setCalculatedData(elements.$vzValue, data.vzValue);
      setCalculatedData(elements.$salaryEsvValue, data.esv);
      setCalculatedData(elements.$salaryValue, data.totalSalary);
      setCalculatedData(elements.$salaryEsvFactValue, data.esvFactValue);

      if (elements.$salaryEsvValueWrap) {
        elements.$salaryEsvValueWrap.style.display = isESVFactFieldVisible(fieldsData) ? '' : 'none';
      }


      return this;
    };

    this.toggleTable = function (state) {
      if (elements.table) {
        if (Boolean(state)) {
          elements.table.style.display = 'table';
        } else {
          elements.table.style.display = 'none';
        }
      }

      return this;
    };

    (function init() {
      initElements();
    })();
  }

  function calculateSalary(config, coef) {
    let PDFO = 0,
        pspValue = 0,
        totalPSP = 0,
        salaryEDGE = 0,
        totalSalary = 0,
        esv = 0,
        vzValue = config.salary * (coef.yearData.vzValue / 100),
        esvFormRadioValue = config.radioData.dataEsv / 100,
        esvFactValue = coef.yearData.minSalary * esvFormRadioValue,
        totalChildCount = Number(config.childrenCount) || 1,

        childModifiedCount = totalChildCount || 1,
        numberOfChilds = Number(config.childrenCount) || 1,
        numberOfCrippleCount = Number(config.childrenCrippleCount) || 0,
        numberOfSalary = Number(config.salary),
        numberUsualNsl = Number(String(coef.yearData.usual_nsl).replace(/,/g, '.')),
        numberHigherNsl = Number(String(coef.yearData.higher_nsl).replace(/,/g, '.')),
        numberMaxNsl = Number(String(coef.yearData.max_nsl).replace(/,/g, '.')),
        numberAmaountIncome = Number(String(coef.yearData.amount_of_income).replace(/,/g, '.')),
        pspSelfValue = Number(config.radioData.dataPspSelf);



    if (numberOfChilds < numberOfCrippleCount) {
      numberOfChilds = numberOfCrippleCount;
      totalChildCount = numberOfChilds;
    }
    pspValue = numberAmaountIncome * totalChildCount;

    if (pspSelfValue === 100) {
      if (!numberOfCrippleCount) {
        totalPSP = totalChildCount * numberUsualNsl;
      } else {
        totalPSP = (totalChildCount-numberOfCrippleCount) * numberUsualNsl + numberOfCrippleCount * numberHigherNsl;
      }
    } else if (pspSelfValue === 150) {
      totalPSP = totalChildCount * numberHigherNsl;
    } else if (pspSelfValue === 200) {
      totalPSP = numberMaxNsl;
    }

    if (pspValue < numberOfSalary) {
      totalPSP = 0;
    }

    salaryEDGE = pspValue * childModifiedCount;
    PDFO = (numberOfSalary - totalPSP) * 0.18;
    PDFO = PDFO < 0 ? 0 : PDFO;
    totalSalary = numberOfSalary - PDFO - vzValue;
    if ((coef.yearData.minSalary * coef.yearData.esv_rate) > numberOfSalary) {
      esv = numberOfSalary * esvFormRadioValue;
    } else {
      esv = (coef.yearData.minSalary * coef.yearData.esv_rate) * esvFormRadioValue;
    }
    esvFactValue = coef.yearData.minSalary * esvFormRadioValue;


    return {
      esvFactValue: esvFactValue.toFixed(2),
      salary: Number(config.salary).toFixed(2),
      pspValue: pspValue.toFixed(2),
      vzValue: vzValue.toFixed(2),
      PDFO: PDFO.toFixed(2),
      totalSalary: totalSalary.toFixed(2),
      esv: esv.toFixed(2),
      salaryEDGE: salaryEDGE.toFixed(2),
      totalPSP: totalPSP.toFixed(2)
    };
  }

  function SalaryFacade(initConfig) {
    let dependencies = initConfig.dependencies || {},
        SalaryFields = dependencies.SalaryFields,
        SalaryResults = dependencies.SalaryResults,
        calculateSalary = dependencies.calculateSalary,
        callbacksCollection = {
          changeSalary: new Set()
        },
        fieldsData = {};

    function getCase(config) {
      let childrenCount = Number(config.childrenCount),
          childrenCrippleCount = Number(config.childrenCrippleCount),
          childCase = 0;

      if (childrenCount && !childrenCrippleCount) {
        childCase = 2;
      }

      if (!childrenCount && childrenCrippleCount) {
        childCase = 1;
      }

      if (childrenCount && childrenCrippleCount) {
        childCase = 3;
      }

      if (!childrenCount && !childrenCrippleCount) {
        childCase = 2;
      }

      return childCase;
    }

    function calculateSalaryHandler(config) {
      fieldsData = config;
      fieldsData.case = getCase(fieldsData);

      callbacksCollection.changeSalary.forEach(function(callback) {
        callback(fieldsData);
      });
    }

    function subscribeToCallbacks() {
      SalaryFields.subscribe('calculateSalary', calculateSalaryHandler);
    }

    this.setCoef = function (coef) {
      SalaryResults.setData(calculateSalary(fieldsData, coef), fieldsData).toggleTable(true);

      return this;
    };

    this.subscribe = function (type, callback) {
      callbacksCollection[type].add(callback);
    };

    (function init() {
      subscribeToCallbacks();
    })();
  }

  function SalaryService(initConfig) {
    let dependencies = initConfig.dependencies || {},
        Facade = dependencies.Facade,
        childData = {},
        yearData = {};


    function sendRequest(config) {
      // const baseUrl = document.querySelector('.calculate').getAttribute('data-host');
      const urlWithParams = new URLSearchParams();
      if (config.data) {
        Object.keys(config.data).forEach(key => {
          urlWithParams.append(key, config.data[key]);
        });
      }

      fetch(`${config.url}?${urlWithParams.toString()}`, {
        method: 'GET',

        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
      })
          .then(response => response.json())
          .then(res => {
            if (typeof config.successHandler === 'function') {
              config.successHandler(res);
            }
          })
          .catch(error => {
            console.error('Request failed', error);
          });
    }

    function getChildData(config) {
      if (config && config.case) {
        sendRequest({
          url: '/nsl-calculator/get-children-table',
          // data: {case: '2'},
          data: {case: config.case},
          successHandler: function (res) {
            childData = window.JSON.parse(res.data);

            Facade.setCoef({yearData: yearData, childData: childData});
          }
        });
      }
    }
    function refreshSalary(config) {
      if (config && config.case) {
        sendRequest({
          url: '/nsl-calculator/get-min-salary',
          type: 'GET',
          data: {date_from: config.dateFrom, date_to: config.dateFrom},
          successHandler: function(res) {
            yearData.minSalary = res[0].min_salary;
            yearData.esv_rate = res[0].esv_rate;
            yearData.vzValue = res[0].military_percent;
            getChildData(config);

          },
        });
      }
    }

    function changeSalaryHandler(config) {
      if (config && config.dateFrom) {
        sendRequest({
          url: '/nsl-calculator/get-year-table',
          data: {year: config.dateFrom.substring(config.dateFrom.length - 4)},
          successHandler: function (res) {
            yearData = window.JSON.parse(res.data);
            refreshSalary(config);
            // yearData.minSalary = res.min_salary;
          }
        });
      }
    }

    function subscribeToCallbacks() {
      Facade.subscribe('changeSalary', changeSalaryHandler);
    }

    (function init() {
      subscribeToCallbacks();
    })();
  }

  var SalaryFieldsFormInst = new SalaryFields(),
      SalaryResultsInst = new SalaryResults({
        selectors: {
          wrapper: '.calc-section__result-section',
          table: '.calc-section__result-section-wrap',
          pspValue: '.calc-section__result-section-results-wrap--psp b',
          pspEdgeValue: '.calc-section__result-section-results-wrap--psp-final b',
          ndflValue: '.calc-section__result-section-results-wrap--ndfl b',
          vzValue: '.calc-section__result-section-results-wrap--vz b',
          salaryValue: '.calc-section__result-section-results-wrap--salary b',
          salaryEsvValue: '.calc-section__result-section-results-wrap--esv b',
          salaryEsvFactValue: '.calc-section__result-section-results-wrap--esv-fact b',
          salaryEsvFactValueWrap: '.calc-section__result-section-results-wrap--esv-fact'
        }
      }),
      SalaryFacadeInst = new SalaryFacade({
        dependencies: {
          SalaryFields: SalaryFieldsFormInst,
          SalaryResults: SalaryResultsInst,
          calculateSalary: calculateSalary
        }
      }),
      SalaryServiceInst = new SalaryService({
        dependencies: {
          Facade: SalaryFacadeInst
        }
      });

}

document.addEventListener("DOMContentLoaded", function() {
  const salaryCalculator = document.querySelector('.js--salary-calc');
  if (salaryCalculator) {
    const updateMinusState = function (input) {
      const minusButton = input.parentElement.querySelector('.minus');
      if (parseInt(input.value) === 0) {
        minusButton.classList.add('disabled');
      } else {
        minusButton.classList.remove('disabled');
      }
    };

    function triggerInputEvent(input) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    document.querySelectorAll('.minus').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const input = this.parentElement.querySelector('input');
        let count = parseInt(input.value) - 1;
        if (isNaN(count)) count = 0;
        count = count < 0 ? 0 : count;
        input.value = count;

        triggerInputEvent(input);
        updateMinusState(input);
      });
    });

    document.querySelectorAll('.plus').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const input = this.parentElement.querySelector('input');
        let count = parseInt(input.value) + 1;
        if (isNaN(count)) count = 1;
        input.value = count;
        triggerInputEvent(input);
        updateMinusState(input);
      });
    });

    document.querySelectorAll('.minus').forEach(function (button) {
      const input = button.parentElement.querySelector('input');
      updateMinusState(input);
    });

    salaryCalc();
  }





});

